import "./ChecksumModal.css";
import "components/TextBoxModifyMui.css";
import "components/Scroll/Scroll.css";

import { useRef } from "react";
import Draggable from "react-draggable";

import { Close } from "@mui/icons-material";
import {
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	IconButton,
	Tooltip,
} from "@mui/material";

import Table from "components/Table/Table";
import KsprButton from "components/UI/buttons/KsprButton";

import { ProjectNeighboursSelect } from "./ProjectNeighboursSelect";
import { useChecksumModalTableColumsSettings } from "./useChecksumModalTableColumsSettings";

export const ChecksumModal = ({
	downloadChecksum,
	onClose,
	tableData,
	setTableData,
	projectNeighbours,
	selectedProjectNeighbour,
	setSelectedProjectNeighbour,
}) => {
	const scrollBlock = useRef();

	const columnsData = useChecksumModalTableColumsSettings();

	return (
		<Draggable handle=".ChecksumModalTitle">
			<Dialog
				open
				className="ChecksumModalBox"
				sx={{
					"& .MuiDialog-paper": {
						width: "80vw",
						maxWidth: "80vw",
						height: "800px",
					},
				}}
				slotProps={{
					backdrop: {
						sx: { backgroundColor: "transparent" },
					},
				}}
				onKeyDown={(e) => {
					if (e.key === "Escape") {
						onClose();
					}
				}}
			>
				<DialogTitle className="ChecksumModalTitle">
					<div>Сравнение контрольных сумм</div>
					<ProjectNeighboursSelect options={projectNeighbours} value={selectedProjectNeighbour} setValue={setSelectedProjectNeighbour} />
					<Tooltip title="Закрыть">
						<IconButton onClick={() => onClose()}>
							<Close />
						</IconButton>
					</Tooltip>
				</DialogTitle>
				<DialogContent className="ChecksumModalContent thin-scroll">
					<Table
						rowData={tableData}
						columnsData={columnsData}
						scrollBlock={scrollBlock}
						options={{
							selectOptions: {
								controlled: true,
							},
							displayOptions: {
								scrollHeightControll: 20,
							},
						}}
						funcs={{
							setTableData: ({ newTableData }) => setTableData(newTableData),
						}}
					/>
				</DialogContent>
				<DialogActions>
					<div className="MonitorModalbtnWrapper">
						<KsprButton sx={{ ml: "auto" }} variant="text" label="Скачать XSLX" onClick={() => downloadChecksum()} />
					</div>
				</DialogActions>
			</Dialog>
		</Draggable>
	);
};
